// pages/TimeoutWarning.jsx
import { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import Nav from '../components/Nav';

const TimeoutWarning = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(30); 
  const hasLoaded = useRef(false);
    
  function loadScript(src, options = {}) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;

        // Options for loading behavior
        if (options.async)  script.async = true;
        if (options.defer)  script.defer = true;

        script.onload = () => resolve(script);
        script.onerror = () => reject(new Error(`Failed to load ${src}`));

        document.body.appendChild(script);
    });
  }  

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      // navigate('/lockscreen'); 
    }, 15000); 

    if (hasLoaded.current) return;
        hasLoaded.current = true;

    (async () => {
        try {

        console.log('Loading Bootstrap...');
        await loadScript('/assets/js/components/session-timeout/bootstrap-session-timeout.js', { async: true });

        console.log('Loading Timeout js...');
        await loadScript('/assets/js/components/session-timeout/custom-bootstrap_session_timeout.js', { defer: true });

        console.log('All scripts loaded in order!');
   
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = process.env.PUBLIC_URL + '/assets/css/apps/timeoutwarning.css';
        document.head.appendChild(link);
        
        } catch (err) {
        console.error(err);
        }
    })();

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate]);

  const stayLoggedIn = () => {
    navigate('/dashboard'); 
  };

  return (
        <div>
            <div id="load_screen" style={{display : 'none'}}> <div className="loader"> <div className="loader-content">
            <div className="spinner-grow align-self-center"></div>
            </div></div></div>
            <div className="main-container" id="container">
                <div className="overlay"></div>
                <div className="search-overlay"></div>
                <Nav/>
            </div>
            <div id="content" class="main-content">
                <div class="layout-px-spacing">
                    <div class="page-header">
                        <nav class="breadcrumb-one" aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="javascript:void(0);">Components</a></li>
                                <li class="breadcrumb-item active" aria-current="page"><a href="javascript:void(0);">Session Timeout</a></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
  );
};

export default TimeoutWarning;
